import thunk from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { all, call } from 'redux-saga/effects'
import { createLogger } from 'redux-logger'
import { combineReducers } from 'redux'
import { reducerMap } from '../redux/reducers/root_reducer'
import { sagas } from "./sagas/root_saga"
import { compose } from '../util/api_utils'
import * as config from '../config'
import history from './history'
import { routerMiddleware } from 'react-router-redux'
import { Sitka } from "olio-sitka"

import { INITIAL_STATE } from './core'
import OAuthModule from './modules/oauth'
import NavigationModule from './modules/navigation'
import WebhookSubscriptionsModule from './modules/webhook_subscriptions'
import GoogleCalendarConfigsModule from './modules/google_calendar_configs'
import ZoomConfigsModule from './modules/zoom_configs'

const sitka = new Sitka({
    sitkaInState: false,
})
sitka.register([
    new OAuthModule(),
    new NavigationModule(),
    new WebhookSubscriptionsModule(),
    new GoogleCalendarConfigsModule(),
    new ZoomConfigsModule(),
])
const sitkaMeta = sitka.createSitkaMeta()

const appReducer = combineReducers({ 
    ...sitkaMeta.reducersToCombine, 
    ...reducerMap, 
})
const rootReducer = (state, action) => {
    if(action.type === 'RESET') {
        state = undefined
    }

    return appReducer(state, action)
}

function* sagaRoot() {
    yield all([...sagas()])
    yield call(sitkaMeta.sagaRoot)
}

// *** NOTE: Add logger middleware for dev/debugging,
// *** but turn off otherwise, because it slows down performance.
const logger = createLogger({ stateTransformer: state => state })
const sagaMiddleware = createSagaMiddleware()
const historyRouterMiddleware = routerMiddleware(history)
const middleware = config.isDev ? [thunk, logger, sagaMiddleware, historyRouterMiddleware] : [thunk, sagaMiddleware, historyRouterMiddleware]

const createStoreWithMiddleware = compose(
    applyMiddleware.apply(this, middleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
)(createStore)

const store = createStoreWithMiddleware(rootReducer, {
    ...INITIAL_STATE,
    ...sitkaMeta.defaultState,
})
sagaMiddleware.run(sagaRoot)
sitka.setDispatch(store.dispatch)

export {
    sitka,
}
export default store


// WEBPACK FOOTER //
// ./src/redux/store.js